import { Injectable } from '@angular/core';
import { Config, OccConfig } from '@spartacus/core';
import { AlertType } from '../../../../core/model';

@Injectable({
  providedIn: 'root',
  useExisting: Config,
})
export abstract class AlertsConfig extends OccConfig {
  alerts?: {
    /**
     * Specify the alert types that will reappear after dismissal.
     */
    reappearableAlerts?: AlertType[];
    /**
     * Specify the time in seconds until an alert reappears.
     */
    reappearTime?: number;
    /**
     * Specify the time in seconds before the operational message is checked the first time.
     */
    operationalMessageCheckInitialDelay: number;
    /**
     * Specify the time in seconds how often operational message is checked.
     */
    operationalMessageCheckInterval: number;
  };
}
